<template>
  <v-expansion-panels v-model="pierPanels" multiple color="#fff">
    <v-expansion-panel>
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!pierPanels.includes(0)" icon="fa-solid fa-plus" />
        <v-icon v-if="pierPanels.includes(0)" icon="fa-solid fa-minus" />
        <h3>
          Pier
          {{
            pier?.strUnitLabel.includes("Pier")
              ? pier?.strUnitLabel.split(" ")[1].length == 1
                ? "0" + pier?.strUnitLabel.split(" ")[1]
                : pier?.strUnitLabel.split(" ")[1]
              : pier?.strUnitLabel.split("P")[1]
          }}
        </h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-expansion-panels v-model="pierSubPanels" multiple color="#fff">
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!pierSubPanels.includes(0)" icon="fa-solid fa-plus" />
              <v-icon v-if="pierSubPanels.includes(0)" icon="fa-solid fa-minus" />
              <h3>
                Pier
                {{
                  pier?.strUnitLabel.includes("Pier")
                    ? pier?.strUnitLabel.split(" ")[1].length == 1
                      ? "0" + pier?.strUnitLabel.split(" ")[1]
                      : pier?.strUnitLabel.split(" ")[1]
                    : pier?.strUnitLabel.split("P")[1]
                }}
                Inspection Notes
              </h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <v-row class="pt-4 pb-4">
                <v-btn
                  id="btn_copyPierData"
                  variant="outlined"
                  class="mx-3 my-2"
                  :disabled="!isEditable"
                  @click="showCopyPierDataPopupFunction(pier)"
                  >Copy Pier Notes</v-btn
                >
              </v-row>
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                id="textarea_backwall_pier"
                :inspectionCommentType="INSPECTION_COMMENTS.CONDITION_SUMMARY_PIER"
                :readOnly="!isEditable"
                label="Condition Summary"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="pier?.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                id="textarea_bridge_seats_pier"
                :inspectionCommentType="INSPECTION_COMMENTS.BRIDGE_SEATS_PIER"
                :readOnly="!isEditable"
                label="Bridge Seats"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="pier?.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                id="textarea_cheekwalls_pier"
                :inspectionCommentType="INSPECTION_COMMENTS.CHEEKWALLS_PIER"
                :readOnly="!isEditable"
                label="Cheekwalls"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="pier?.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                id="textarea_stem_pier"
                :inspectionCommentType="INSPECTION_COMMENTS.COLUMNS_STEMS_PIER"
                :readOnly="!isEditable"
                label="Columns/Stems"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="pier?.structureUnitId"
                @updateComment="handleUpdate()"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                id="textarea_settlement_pier"
                :inspectionCommentType="INSPECTION_COMMENTS.SETTLEMENT_PIER"
                :readOnly="!isEditable"
                label="Settlement"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="pier?.structureUnitId"
                @updateComment="handleUpdate()"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="isStructureUnitIn500YrFp(pier.strUnitKey, substructureValue.inspectionsUnderwater)">
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!pierSubPanels.includes(1)" icon="fa-solid fa-plus" />
              <v-icon v-if="pierSubPanels.includes(1)" icon="fa-solid fa-minus" />
              <h3>
                Pier
                {{
                  pier?.strUnitLabel.includes("Pier")
                    ? pier?.strUnitLabel.split(" ")[1].length == 1
                      ? "0" + pier?.strUnitLabel.split(" ")[1]
                      : pier?.strUnitLabel.split(" ")[1]
                    : pier?.strUnitLabel.split("P")[1]
                }}
                - Waterway
              </h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <UnderwaterInspection
                :pageValue="INSPECTION_PAGES.SUBSTRUCTURE"
                ref="pierUnderwater"
                :isEditable="isEditable"
                :id="`pier_${pier?.strUnitKey}_Underwater`"
                :strUnitKey="pier.strUnitKey"
                :strUnitLabel="pier.strUnitLabel"
                :legacyStructureType="pier.legacyStructureType"
                @updateUnderwaterInspection="handleUpdate()"
            /></v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!pierSubPanels.includes(subPanelValue)" icon="fa-solid fa-plus" />
              <v-icon v-if="pierSubPanels.includes(subPanelValue)" icon="fa-solid fa-minus" />
              <h3>
                Pier
                {{
                  pier?.strUnitLabel.includes("Pier")
                    ? pier?.strUnitLabel.split(" ")[1].length == 1
                      ? "0" + pier?.strUnitLabel.split(" ")[1]
                      : pier?.strUnitLabel.split(" ")[1]
                    : pier?.strUnitLabel.split("P")[1]
                }}
                - NSTM/Fatigue
              </h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <NSTMFatigueTable
                id="'pier_NSTMFatigue_Table'"
                :moduleType="moduleType"
                substructureFatigueTable
                spanBySpanFatigueTable
                :unitKey="pier?.strUnitKey"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
  <v-dialog v-model="showCopyPierDataPopup" :width="800">
    <v-card>
      <v-card-title>
        <span class="text-h5">Copy/Append Pier Data</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col xl="6" lg="7" md="8" sm="9" cols="9" class="pt-6">
            <v-label class="bold">Target Pier: </v-label></v-col
          >
          <v-col xl="6" lg="5" md="4" sm="3" cols="3" style="display: flex; align-items: center">
            <v-select id="select_pier_one" :items="pierLabels" hide-details v-model="selectedPier"> </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="btn_Details_Save"
          variant="outlined"
          class="mx-5"
          :disabled="selectedPier == null"
          @click="copyPierData()"
        >
          Ok
        </v-btn>
        <v-btn id="btn_Details_Close" variant="outlined" class="mx-5" @click="showCopyPierDataPopup = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref } from "vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import NSTMFatigueTable from "@/components/shared/NSTMFatigueTable.vue";
import UnderwaterInspection from "@/components/inspection/substructureComponents/UnderwaterInspection.vue";
import { isStructureUnitIn500YrFp } from "@/composables/waterways.js";
import { useSubstructureStore } from "@/components/inspection/store/substructure";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useSnackbarStore } from "@/stores/snackbar";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { useInspectionStore } from "@/stores/inspection";

export default {
  name: "PiersSubstructure",
  props: {
    pier: { default: null },
    isEditable: { default: false },
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    //Common Code
    const configStore = useConfigStore();
    const substructureStore = useSubstructureStore();
    let substructureValue = computed(() => substructureStore.pageData);
    const snackbarStore = useSnackbarStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const inspectionStore = useInspectionStore();

    let piers = computed(() => substructureStore.getPiers(substructureValue.value));

    const pierPanels = ref([0]);

    const pierSubPanels = ref([0, 1, 2]);

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    let pierUnderwater = ref(null);

    let snackBarId = ref("");
    let snackBarIdenticalId = ref("");
    //Pier Code

    let subPanelValue = ref(
      isStructureUnitIn500YrFp(props.pier.strUnitKey, substructureValue.value.inspectionsUnderwater) ? 2 : 1
    );

    let pierLabels = ref([]);

    let showCopyPierDataPopup = ref(false);
    let targetPier = null;
    let currentPierConditionSummaryIndex;
    let currentPierBridgeSeatsIndex;
    let currentPierCheekWallsIndex;
    let currentPierStemIndex;
    let currentPierSettlementIndex;
    let currentPierCombustibleIndex;
    function showCopyPierDataPopupFunction(pier) {
      targetPier = pier;
      currentPierConditionSummaryIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.CONDITION_SUMMARY_PIER
      );
      currentPierBridgeSeatsIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.BRIDGE_SEATS_PIER
      );
      currentPierCheekWallsIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.CHEEKWALLS_PIER
      );
      currentPierStemIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.COLUMNS_STEMS_PIER
      );
      currentPierSettlementIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.SETTLEMENT_PIER
      );
      currentPierCombustibleIndex = substructureStore.getSubstructureCommentIndex(
        pier,
        INSPECTION_COMMENTS.COMBUSTIBLE_MATERIAL_PIER
      );
      pierLabels.value = [];
      for (const pierFromArray of piers.value ?? []) {
        if (pier?.strUnitLabel != pierFromArray?.strUnitLabel) {
          pierLabels.value.push(pierFromArray?.strUnitLabel);
        }
      };
      showCopyPierDataPopup.value = true;
    }
    let selectedPier = ref(null);

    function copyPierData() {
      let editOccured = [];
      let selectedPierConditionSummaryIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.CONDITION_SUMMARY_PIER
      );
      editOccured.push(
        copyData(
          selectedPierConditionSummaryIndex,
          currentPierConditionSummaryIndex,
          INSPECTION_COMMENTS.CONDITION_SUMMARY_PIER
        )
      );
      let selectedPierBridgeSeatsIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.BRIDGE_SEATS_PIER
      );
      editOccured.push(
        copyData(selectedPierBridgeSeatsIndex, currentPierBridgeSeatsIndex, INSPECTION_COMMENTS.BRIDGE_SEATS_PIER)
      );
      let selectedPierCheekWallsIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.CHEEKWALLS_PIER
      );
      editOccured.push(
        copyData(selectedPierCheekWallsIndex, currentPierCheekWallsIndex, INSPECTION_COMMENTS.CHEEKWALLS_PIER)
      );
      let selectedPierStemIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.COLUMNS_STEMS_PIER
      );
      editOccured.push(copyData(selectedPierStemIndex, currentPierStemIndex, INSPECTION_COMMENTS.COLUMNS_STEMS_PIER));
      let selectedPierSettlementIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.SETTLEMENT_PIER
      );
      editOccured.push(
        copyData(selectedPierSettlementIndex, currentPierSettlementIndex, INSPECTION_COMMENTS.SETTLEMENT_PIER)
      );
      let selectedPierCombustibleIndex = substructureStore.getSubstructureCommentIndex(
        substructureStore.getStructureUnitFromLabel(selectedPier.value),
        INSPECTION_COMMENTS.COMBUSTIBLE_MATERIAL_PIER
      );
      editOccured.push(
        copyData(
          selectedPierCombustibleIndex,
          currentPierCombustibleIndex,
          INSPECTION_COMMENTS.COMBUSTIBLE_MATERIAL_PIER
        )
      );
      if (editOccured.includes(true)) {
        snackBarId.value = snackbarStore.showMessage({
          displayText: "Save is necessary to save the copied data.",
          timeout: 3000,
          callback: onHideSnackbar,
        });
      } else {
        snackBarIdenticalId.value = snackbarStore.showMessage({
          displayText: targetPier.strUnitLabel + " and " + selectedPier.value + " notes are identical.",
          timeout: 3000,
          callback: onHideSnackbar,
        });
      }
      handleUpdate();
      targetPier = null;
      showCopyPierDataPopup.value = false;
      selectedPier.value = null;
    }

    async function validate() {
      await pierUnderwater.value.validate();
      return pierUnderwater.value.valid;
    }

    function onHideSnackbar() {
      snackbarStore.removeMessage(snackBarId.value);
      snackbarStore.removeMessage(snackBarIdenticalId.value);
    }

    function copyData(select, current, commentType) {
      if (
        select != -1 &&
        current != -1 &&
        substructureValue.value.structureUnitInspComments[select].notes !=
          substructureValue.value.structureUnitInspComments[current].notes
      ) {
        substructureValue.value.structureUnitInspComments[select].notes =
          substructureValue.value.structureUnitInspComments[current].notes;
        substructureValue.value.structureUnitInspComments[select].updateDateTime = null;
        return true;
      } else if (select == -1 && current != -1) {
        substructureValue.value.structureUnitInspComments.push({
          brkey: substructureValue.value.brkey,
          commentType: commentType,
          inspectionId: substructureValue.value.inspectionId,
          updateDateTime: null,
          notes: substructureValue.value.structureUnitInspComments[current].notes,
          structureUnitId: substructureStore.getStructureUnitFromLabel(selectedPier.value)?.structureUnitId,
          updateUserId: null,
        });
        return true;
      } else if (select != -1 && current == -1) {
        substructureValue.value.structureUnitInspComments[select].notes = "";
        substructureValue.value.structureUnitInspComments[select].updateDateTime = null;
        return true;
      } else {
        return false;
      }
    }

    const handleUpdate = () => {
      if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
        inspectionLinksStore.isDirty = true;
      } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
        inspectionStore.setDirtyFlag(true);
      }
    };
    return {
      handleUpdate,
      INSPECTION_PAGES,
      substructureValue,
      MODULE_TYPES,
      isStructureUnitIn500YrFp,
      subPanelValue,
      piers,
      pierSubPanels,
      validate,
      pierUnderwater,
      showCopyPierDataPopupFunction,
      selectedPier,
      pierLabels,
      showCopyPierDataPopup,
      copyData,
      copyPierData,
      pierPanels,
      commentsMaxLength,
      INSPECTION_COMMENTS,
    };
  },
  components: {
    StructureUnitCommentTypeTextField,
    NSTMFatigueTable,
    UnderwaterInspection,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
</style>
